import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ExceptionService, UtilsService } from '../../xform-compat';
import { RmsBasicCrudService } from '../components/rms-basic-crud.service';
import { CfvCalculationSummary } from '../../shared/models/company/cfv-calculation-summary.model';

/**
 * Service for retrieving CFV (calculated fair value) calculation summaries.
 */
@Injectable({
  providedIn: 'root'
})
export class CfvCalculationService extends RmsBasicCrudService<CfvCalculationSummary> {

  private readonly basePath = '/api/rms/fairValueCalculations/summaries';

  constructor(
    http: HttpClient,
    utilsService: UtilsService,
    exceptionService: ExceptionService
  ) {
    super(http, utilsService, exceptionService);
  }

  /** Retrieves calculation summaries for the given company IDs */
  public getSummaries(companyIds: Array<number>): Observable<Array<CfvCalculationSummary>> {
    return this.getHttp().post<Array<CfvCalculationSummary>>(this.basePath, companyIds)
      .pipe(catchError(ex => this.getExceptions().catchBadResponse(ex)));
  }
}
